<template>
  <div class="flieBlank">
    <div class="head">
      <input
        class="title"
        :disabled="disabled"
        type="text"
        v-model="title"
        placeholder="请输入空白模板标题"
      />
    </div>
    <div class="footer">
      <div class="sign">
        签字：人员签字板签字 <img src="@/assets/image/finger.png" alt="" />
      </div>
      <div class="time">
        日期： {{ moment(new Date()).format("YYYY-MM-DD") }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: "",
    };
  },
  methods: {
    moment,
  },
};
</script>

<style scoped>
.flieBlank {
  height: 70vh;
  position: relative;
  border: 1px solid #000000;
}
.head {
  background: #ccc;
  color: #000;
  font-weight: bold;
  border-bottom: 1px solid #000000;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  outline: none;
  border: none;
  background: none;
  width: 100%;
  font-size: 20px;
  text-align: center;
  color: #000;
  font-weight: bold;
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 16px;
  /* border: 1px solid red; */
  text-indent: 20px;
  color: #000;
}
.sign {
  position: relative;
}
.sign img {
  position: absolute;
  top: -20px;
  left: 100px;
  width: 60px;
  height: 60px;
  opacity: 0.2;
  transform: rotate(-30deg);
}
.time {
  margin-top: 40px;
  margin-bottom: 20px;
}
</style>